export default "__VITE_ASSET__DqxbI_Gb__"